var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7 14C3.13401 14 2.73984e-07 10.866 6.11959e-07 7C9.49935e-07 3.13401 3.13401 2.73983e-07 7 6.11958e-07C10.866 9.49934e-07 14 3.13401 14 7C14 10.866 10.866 14 7 14Z",
          fill: "#1A2653"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M6.03125 7.21241C6.03125 7.7477 6.46519 8.18164 7.00048 8.18164C7.53577 8.18164 7.96971 7.7477 7.96971 7.21241L7.96971 3.98164C7.96971 3.44635 7.53577 3.01241 7.00048 3.01241C6.46519 3.01241 6.03125 3.44635 6.03125 3.98164L6.03125 7.21241Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "6.99952",
          cy: "10.0151",
          r: "0.969231",
          transform: "rotate(-180 6.99952 10.0151)",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42988ad2", { render: render, staticRenderFns: staticRenderFns })
  }
}